import useMessagingUnreadCountSelectorQuery from '~queries/useMessagingUnreadCountSelectorQuery';
import { Nullable } from '~types/Nullable';

export default function useMessagingChannelUnreadCountQuery(channelId: Nullable<string>) {
  return useMessagingUnreadCountSelectorQuery(
    (unreadCounts) => (channelId ? unreadCounts.forChannel(channelId) : 0),
    { isEnabled: Boolean(channelId) },
  );
}
